import contactImage from ".././assets/contact.webp";

export default function ThankYou() {
    return (
        <div className="ae-page-container ae-not-found-page -fade-in">
            <h1>Thank you for getting in touch.</h1>
            <h3>We've received your message. Our team will be contacting you soon.</h3>
            <a className="ae-link b" href="/">Go to homepage →</a>
            <img className="ae-not-found-image" src={contactImage} alt=""/>
        </div>
    )
}